module.exports = __webpack_public_path__ + "img/foot_ewm1.3797fac2.png";